module.exports = __webpack_public_path__ + "static/media/district54.0ef70df3.pdf";